module.exports = __webpack_public_path__ + "img/pJcb.463e4249.svg";